import { render, staticRenderFns } from "./PersonalizedSiteEdit.vue?vue&type=template&id=3dd1deac"
import script from "./PersonalizedSiteEdit.vue?vue&type=script&lang=js"
export * from "./PersonalizedSiteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports